import PythonApi from "../services/PythonApi";

export default {
  getCowsHeat(payload) {
    const params = new URLSearchParams();

    if (payload.fromDate)
      params.append("from_date", payload.fromDate);

    if (payload.toDate)
      params.append("to_date", payload.toDate);

    if (payload.cowIDs)
      payload.cowIDs.forEach(cow_id => params.append("cow_ids", cow_id));

    if (payload.download)
      params.append("download", true);

    return PythonApi().get("/cows/heat_report", params);
  },

  cowsHeatCsvExport(payload) {
    Object.assign(payload, { download: true });
    return this.getCowsHeat(payload);
  }
};



// WEBPACK FOOTER //
// ./src/api/cow-change-api.js